import React, {createContext,useState} from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './Navbar/Navbar'
import Login from './Login/Login'
import Citta from './Citta/Citta'
import Locali from './Locali/Locali'
import Cibi from './Cibi/Cibi'
import Carrello from './Carrello/Carrello'
import Contattami from './Contattami/Contattami'

//Creo context per passare parametri tra i componenti
export const Passaggio=createContext(); //Context per passare ID citta/locali/cibi/totale
export const User=createContext(); //Context per salvare dati relativi alla mail
export const Ordinazione=createContext(); //Context per ordinazione

const App = () => {
  //Dichiaro stati
  const [citta, setcitta] = useState([])
  const [idCitta, setidCitta] = useState('')
  const [idLocale, setidLocale] = useState('')
  const [idOrdine, setidOrdine] = useState(0)
  const [user, setuser] = useState({})
  const [ordine, setordine] = useState([])
  const [totale, settotale] = useState(0)
  const [qta, setqta] = useState(0)
  //Uso provider per passare stati tra componenti
  //Creo rotte
  return (
    <Passaggio.Provider value={{citta,setcitta, idCitta, setidCitta, idLocale, setidLocale, ordine, setordine, totale, settotale, idOrdine, setidOrdine,qta,setqta}}>
      <User.Provider value={{user, setuser}}>
        <Router>
          <div id='container'>
            <Navbar/>
            <Routes>
              <Route path="/" element={<Login/>}></Route>
              <Route path="/citta" element={<Citta/>}></Route>
              <Route path="/locali" element={<Locali/>}></Route>
              <Route path="/cibi" element={<Cibi/>}></Route>
              <Route path="/carrello" element={<Carrello/>}></Route>
              <Route path="/contattami" element={<Contattami/>}></Route>
            </Routes>
          </div>
        </Router>
      </User.Provider>
    </Passaggio.Provider>
  )
}

export default App
